
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'PageTeamIndex',

  data() {
    return {
      faArrowUpRightFromSquare,
      team: [
        {
          name: 'Rob',
          title: 'Founder and Director',
          image: require('~/assets/images/team/rob.jpg'),
          isBioVisible: false,
          bio: `My name is Rob I started the business back in 2018 when my dog Bramble had a real chase instinct and I was searching for somewhere safe to walk her. After not finding anything suitable, this is when Paw Paddock was born and I opened our first paddock in Chichester. Day to day I am working with my team to push forward us finding new locations, working with Marc to make sure that our paddocks are maintained properly and managing all financial sides of the business.\n
                During the summer months I am fully in the midst of building and working alongside our contractors to bring our paddocks to life and I enjoy still getting stuck in with all parts of the business to support the team.\n
                Outside of work, there is nothing I love more than enjoying delicious food with friends and family. Alongside that, I took up golf 2 years ago to create more of a work-life balance and as a result has become a big passion of mine.`
        },
        {
          name: 'Helen',
          title: 'Marketing Director',
          image: require('~/assets/images/team/helen.jpg'),
          isBioVisible: false,
          bio: `I'm Helen, I am Marketing Director at Paw Paddock. I joined my Husband Rob who founded the company in 2019 running the marketing function. My role is very broad, but I manage everything from our marketing strategy down to creating all social media content, website and email communications.\n
              Since the day I received my Batchelors degree in Marketing, it's always been a passion of mine and something I wanted to pursue, so being able to work on a business that I love feels like a true honour.\n
              We love taking our Spanador Bramble on long walks down by the coast or along the South Downs. When I have time, I love to exercise, last year I completed an Olympic Triathlon and this year I hope to run Brighton Marathon. But nothing can beat spending quality time with family and friends!`
        },
        {
          name: 'Laura',
          title: 'Operations Manager',
          image: require('~/assets/images/team/laura.jpg'),
          isBioVisible: false,
          bio: `I'm Laura, I am the Operations Manager and I joined the team in January 2023.\n
                I work alongside Rob in the search of land for new paddocks. Once a prospective location has been found, I finalise the ins and outs and oversee the planning process. At the exciting point planning permission is granted, I help to get the site ready for your lovely pooches. It is amazing to see the transformation from a grassy field to a Paw Paddock. The other part of my role is providing support to the team in the day to day running of Paw Paddock. We have a such a brilliant team, always thinking of ways to improve and ensure the paddocks are the best they can be.\n
                Outside of work I am busy enjoying my two young children, I love cooking (although I can't bake to save my life), reading, spending time with friends and family and getting out for walks in our beautiful countryside with our labrador Peggy. I love eating out, so good recommendations are always welcome.`
        },
        {
          name: 'Kerstin',
          title: 'Marketing Executive',
          image: require('~/assets/images/team/kerstin.jpg'),
          isBioVisible: false,
          bio: `Hi! I'm Kerstin, the marketing executive here at Paw Paddock.\n
                I joined the Paw Paddock team just over a year ago after completing my bachelor's degree in marketing.\n
                I work very closely with Helen, creating and managing all campaigns across all our social media platforms and website to creating all email communications, as well as promoting the business and building brand awareness to new customers across the South Coast! I also work closely with Lara, our customer service executive, to ensure that our customers are always up to date with all things Paw Paddock, and to ensure that all customers are happy and satisfied with their bookings!\n
                When not working, I love to spend time with friends and family, as well as my lovely lab-cross Aimee. I am also a huge foodie, so any recommendations for new places to eat, or new recipes are always welcomed!`
        }
      ]
    }
  },

  head() {
    return {
      title: 'Team and Careers',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Meet the team behind Paw Paddock and view any open vacancies'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Team and Careers',
        image: require('~/assets/images/backgrounds/team-hero.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  },

  methods: {
    trackJobAdvertClick() {
      this.$analytics.addEvent('Clicked job advert', {
        destination: 'Indeed',
        jobKey: 'f07e056e44ba6a78',
        jobTitle: 'Senior Groundskeeper'
      })
    }
  }
}
